import { Badge, Theme } from "@120wateraudit/waterworks";
import React from "react";

const getColorForMaterialClassification = (
  materialClassification: string,
): string => {
  if (materialClassification === "Non-lead") {
    return Theme.palette.primary;
  }

  if (materialClassification === "Lead Status Unknown") {
    return Theme.palette.secondary;
  }

  if (materialClassification === "Galvanized Requiring Replacement") {
    return Theme.palette.tertiary;
  }

  if (materialClassification === "Lead") {
    return Theme.palette.warning;
  }

  return Theme.palette.primary;
};

interface MaterialBadgeProps {
  materialClassification: string;
  inverse?: boolean;
}

export const MaterialClassificationBadge: React.FC<MaterialBadgeProps> = ({
  materialClassification,
  inverse = false,
}) => {
  const bgColor = inverse
    ? Theme.palette.white
    : getColorForMaterialClassification(materialClassification);

  let textColor: string;
  if (inverse) {
    textColor = getColorForMaterialClassification(materialClassification);
  } else if (bgColor === Theme.palette.warning) {
    textColor = Theme.palette.white;
  } else if (bgColor === Theme.palette.primary || bgColor === Theme.palette.tertiary) {
    textColor = Theme.palette.neutral900;
  } else if (bgColor === Theme.palette.secondary) {
    textColor = Theme.palette.white;
  } else {
    textColor = Theme.palette.white;
  }

  const badgeStyle: React.CSSProperties = {
    justifyContent: inverse ? "left" : "center",
    padding: "6px",
    textAlign: "center",
    minWidth: "150px",
  };

  return (
    <Badge style={badgeStyle} color={textColor} backgroundColor={bgColor}>
      {materialClassification}
    </Badge>
  );
};

export default MaterialClassificationBadge;
